import React, {useContext } from "react";

import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../store/rootStore";
import { IYear } from "../models/year";


interface IProps {
  formChosen: IYear;
}

const YearFormDetail:React.FC<IProps> = observer(({formChosen}) => {

  const rootStore = useContext(RootStoreContext);

  return (
    <div className={`card__detail card__detail_1`}>
      <div className='card__detail-body'>
        <h1>{formChosen.name}</h1>

        <div className='card__detail-content' dangerouslySetInnerHTML={{__html: formChosen.yearFormInformation.content}} />

      </div>
        
    </div>
  )
});

export default YearFormDetail;
